import * as React from 'react';
import { actionCreator as authActions } from '../../common/Auth0/store/actions/creators';
import { IState as ITrainerState } from '../../common/store/trainers/state';
import { IActions as ITrainerActions, actionCreator as trainersActions } from '../../common/store/trainers/actions/creators';
import { IState as ITagState } from '../tags/store/state';
import { IActions as ITagsActions, actionCreator as tagsActions } from '../tags/store/actions/creators';
import { IApplicationState } from '../../store/ApplicationState';
import { TrainerList } from './components/List/TrainerList';
import { Trainer } from './components/Detail/Trainer';
import { Grid, CircularProgress, StyledComponentProps, withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { styles } from './styles';
import { Filters } from './components/Filter/Filters';
import Paper from '../../ui-components/Containers/Paper';
import { WithMediaQuery, IMediaQueryProps } from '../../layout/withMediaQuery';
import { tag } from '../../model/tag';
import { trainer } from '../../model/trainer';

interface IProps extends ITrainerActions, ITrainerState, ITagsActions, ITagState, IMediaQueryProps, StyledComponentProps {
}
interface IState {
    fullnameOrEmail: string;
    tag?: tag;
}

// const DefaultRowsPerPage = 10;

class CompContainer extends React.Component<IProps, IState>
{
    state = {
        fullnameOrEmail: "",
        tag: undefined,
    };

    componentDidMount() {
        // const { id } = this.props.match.params;
        if (!this.props.tags || this.props.tags.length === 0) {
            this.props.loadTags();
        }

        this.props.loadTrainers('', '');
    }

    handleSelection = (_id: string) => {
        // this.setState({ contactsCollapsed: this.props.smallScreen ? true : this.state.contactsCollapsed });
        this.props.loadTrainer(_id);
    }

    private handleChangeFullnameOrEmail = (val: string) => {
        this.setState({ fullnameOrEmail: val });
    }

    private handleChangeTagCode = (val?: tag) => {
        this.setState({ tag: val })
    }

    private search = (fullnameOrEmail: string, tag: tag) => {
        this.props.loadTrainers(fullnameOrEmail, tag ? tag.code : '');
    }

    saveTrainer = (t: trainer) => {
        // this.props.trainers.map((x) => {
        //     if (t._id === x._id)
        //     {
        //         x.name = t.name;   
        //     }
        // });
        this.props.saveTrainer(t);
    }

    onNewTrainerClick = () => {
        this.props.createTrainer();
    }

    render() {
        // const { id } = this.props.match.params;
        // const { classes } = this.props;
        return (
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <Filters
                        handleChangeFullnameOrEmail={this.handleChangeFullnameOrEmail}
                        search={this.search}
                        fullnameOrEmail={this.state.fullnameOrEmail}
                        handleChangeTagCode={this.handleChangeTagCode}
                        selctedTag={this.state.tag}
                        classes={this.props.classes}
                        new={this.onNewTrainerClick}
                        loading={this.props.isLoadingTrainers}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <Paper title='Elenco'
                        collapsed={this.props.smallScreen ? true : false} // true --> this.state.contactsCollapsed 
                        fullHeight={false}
                        contentContainerStyle={this.props.smallScreen ? { minHeight: '300px' } : { heigth: 'calc(100% - 1px)' }}>
                        <Grid container spacing={1}>
                            {this.props.isLoadingTrainers ? 
                                <Grid item xs={12} justify={"center"} style={{ display: 'flex' }}>
                                    <CircularProgress size={80} />
                                </Grid>
                                :
                                <>
                                <Grid item xs={12} >
                                    <TrainerList
                                        classes={this.props.classes}
                                        trainerList={this.props.trainers}
                                        selected={this.props.selectedTrainer?._id}
                                        onTrainerClick={this.handleSelection}
                                        // navigateTo={this.props.navigateTo}
                                    />
                                </Grid>
                                </>
                            }
                        </Grid>
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={6}>
                    {this.props.selectedTrainer ? // this.props.selectedTrainer?._id && 
                    <Paper title='Dati' fullHeight contentContainerStyle={{ padding: 8 }} id="TrainerData">
                        <Grid container spacing={1}>
                            {this.props.isLoadingTrainers || this.props.isLoadingTrainer ? 
                                <Grid item xs={12} justify={"center"} style={{ display: 'flex' }}>
                                    <CircularProgress size={80} />
                                </Grid>
                                : 
                                <Grid item xs={12}>
                                    <Trainer
                                        classes={this.props.classes}
                                        isLoadingTrainer={this.props.isLoadingTrainer}
                                        trainer={this.props.selectedTrainer}
                                        saveTrainer={(t) => this.saveTrainer(t)}
                                        tags={this.props.tags}
                                    />                                        
                                </Grid>
                                }
                        </Grid>
                    </Paper>
                    :
                    <></>    
                    }
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state: IApplicationState, ownP) => ({
    ...state.trainers,
    ...state.tags,
    ...ownP
})

const mapDispatchToProps = (dispatch: any) => ({
    ...trainersActions(dispatch),
    ...tagsActions(dispatch),
    navigateTo: authActions(dispatch).navigateTo
})

export const Trainers = connect(mapStateToProps, mapDispatchToProps)(WithMediaQuery(withStyles(styles)(CompContainer)));